import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Typewriter from 'typewriter-effect/dist/core';
import initSplitTitle from './utils/init-split-title';

const initSwiper = (selector, options, viewportAutoplay) => {
  const element = document.querySelector(selector);
  if (!element) return;

  let swiperOptions = options;

  if (viewportAutoplay && options.autoplay) {
    swiperOptions = {
      ...options,
      autoplay: { ...options.autoplay, enabled: false },
    };
  }

  const swiper = new Swiper(element, swiperOptions);

  if (viewportAutoplay && options.autoplay) {
    const { sectionSelector = selector, threshold = 0.2 } = viewportAutoplay;
    const section = document.querySelector(sectionSelector);

    if (section) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              swiper.autoplay.start();
            } else {
              swiper.autoplay.stop();
            }
          });
        },
        { threshold }
      );

      observer.observe(section);
    }
  }

  return swiper;
};

const initTyping = ({
  selector,
  threshold = 0.3,
  speed = 60,
  cursor = '|',
  startDelay = 0,
}) => {
  const element = document.querySelector(selector);
  if (!element) return;

  const text = element.innerHTML.trim();
  if (!text) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        element.classList.remove('typing-hidden');

        const typewriter = new Typewriter(element, {
          loop: false,
          delay: speed,
          cursor
        });

        typewriter
          .pauseFor(startDelay)
          .callFunction(() => {
            if (element.classList.contains('is-hidden-typing-wait')) {
              element.classList.add('typing-started');
            }
          })
          .typeString(text)
          .start();

        observer.disconnect();
      });
    },
    { threshold }
  );

  observer.observe(element);
};

document.addEventListener('DOMContentLoaded', () => {
  initSwiper('.news__swiper', {
    slidesPerView: "auto",
    spaceBetween: 15,
  
    navigation: {
      nextEl: '.news__arrow-next',
      prevEl: '.news__arrow-prev',
    },
  
    pagination: {
      el: '.news__progress',
      type: 'progressbar',
    },
  
    breakpoints: {
      961: {
        slidesPerView: "auto",
        spaceBetween: 15,
        slidesOffsetBefore: 48,
        slidesOffsetAfter: 48,
      },
  
      481: {
        slidesPerView: 3,
        spaceBetween: 12,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
      },
  
      0: {
        slidesPerView: "auto",
        spaceBetween: 12,
        slidesOffsetBefore: 12,
        slidesOffsetAfter: 12,
      },
    },
  });

  initSwiper('.experience__swiper', {
    slidesPerView: "auto",
    spaceBetween: 16,
    slidesOffsetBefore: 48,
    slidesOffsetAfter: 48,
    navigation: {
      nextEl: '.experience__arrow-next',
      prevEl: '.experience__arrow-prev',
    },
    breakpoints: {
      961: {
        slidesPerView: "auto",
        slidesOffsetBefore: 48,
        slidesOffsetAfter: 48,
      },
  
      481: {
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
      },
  
      0: {
        spaceBetween: 12,
        slidesOffsetBefore: 12,
        slidesOffsetAfter: 12,
      },
    }
  });

  initTyping({
    selector: '.people__text',
    threshold: 0.3,
    cursor: '▉',
    startDelay: 1000
  });

  initSplitTitle();
});